import { Form } from "../Support/Form";
import { axios } from "../Support/axios";

export class Funds extends Form {

    constructor(data = {}) {
        super(data);

        this.data.account_id = null;
        this.data.account_fund_id = null;

        this.funds = false;
        this.recent_payments = false;
        this.accounts = false;
        this.banking = false;

        this.account_funds = [];
        this.gateway_types = [];

        this.selected_currency = false;
    }

    getAccounts() {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get('/api/account/fund?no_pagination=true', self.data)
                .then(response => {
                    self.accounts = response.data.data;
                    self.banking = response.data.banking;

                    if (self.accounts.length === 1) {
                        self.data.account_id = self.accounts[0].id;
                    }

                    self.selectAlternateAccount();

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);

                    reject(error);
                })
        });
    }

    getBankingDetails(key = null) {
        const currency = this.selected_currency

        if (currency) {
            let details = this.banking[currency.toLowerCase()];

            return key !== null ? details[key] : details;
        }

        return false;
    }

    selectAccount() {
        let self = this;

        return new Promise((resolve, reject) => {
            self.data.reference = Math.random().toString(36).substring(16);

            resolve(true);
        });
    }

    getFunds(accountId = null) {
        let self = this;
        let url = accountId ? `/api/account/${accountId}/funds` : `/api/funds`;
        return new Promise((resolve, reject) => {
            axios.get(url, self.data)
                .then(response => {

                    self.funds = response.data.data;

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);

                    reject(error);
                })
        });
    }

    getRecentPayments() {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get('/api/payment/recent', self.data)
                .then(response => {

                    self.recent_payments = response.data.data;

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);

                    reject(error);
                })
        });
    }

    createPayment() {
        let self = this;
        let data = this.sanitizeData(['amount']);

        self.resetFormMessages().then(result => {
            self.setFormUpdating();
        });

        return new Promise((resolve, reject) => {
            axios.post('/api/payment', data)
                .then(response => {

                    let payment = response.data.data;

                    self.setSuccessMessage('Payment Created, Payment Reference <strong>' + payment.id + '</strong>', false)
                    self.setFormUpdateComplete();

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);

                    reject(error);
                })
        });
    }

    adjustFund(fundId, accountId) {
        let self = this;
        let data = this.sanitizeData(['amount']);
        data['account_id'] = accountId;

        self.resetFormMessages().then(result => {
            self.setFormUpdating();
        });

        return new Promise((resolve, reject) => {
            axios.put('/api/funds/' + fundId, data)
                .then(response => {
                    let fund = response.data.data;

                    self.setFormUpdateComplete();

                    resolve(true);
                }).catch(error => {
                    self.setError(error);

                    reject(error);
                })
        });
    }

    regenerateReference(account) {
        let self = this;

        if (account) {
            let name = account.name.replace(' ', '');

            self.data.reference = name.substr(0, 4).toUpperCase();
        }

        self.data.reference = self.data.reference + self.generateRandomString().toUpperCase();
    }

    generateRandomString(length = 8)  {
        return Math.random().toString(20).substr(2, length);
    }

    selectAlternateAccount() {
        let self = this;

        if (self.data.account_id) {
            let account = this.findByAccountId(self.data.account_id);

            self.account_funds = account.account_funds;
            self.gateway_types = account.gateway_types;

            self.data.type = null;
            self.data.gateway = null;

            this.regenerateReference(account);
        }
    }

    findByAccountId(id) {
        return this.accounts.find(function (account) {
            return account.id === id;
        });
    }

}
